import { useRef, useEffect, useCallback } from 'react';

type SomeFunction = (...args: unknown[]) => void;

export function useDebounce<Func extends SomeFunction>(func: Func, delay = 1000): Func {
  const timer = useRef<ReturnType<typeof setTimeout>>();

  const debouncedFunction = useCallback(
    (...args: unknown[]) => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
      timer.current = setTimeout(() => {
        func(...args);
      }, delay);
    },
    [func, delay],
  ) as Func;

  // Cleanup on component unmount
  useEffect(() => {
    return () => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
    };
  }, []);

  return debouncedFunction;
}
